import { ReactNode } from 'react';
import { Autoplay, FreeMode } from 'swiper/modules';
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react';

import 'swiper/css/free-mode';
import 'swiper/css/pagination';

import 'swiper/css';

interface SwiperSliderProps<T> {
  items: T[];
  renderItem: (item: T, index: number) => ReactNode;
  swiperOptions?: SwiperProps;
}

const SwiperMobileSlider = <T,>({ items, renderItem, swiperOptions = {} }: SwiperSliderProps<T>) => {
  const validateItems = items.length < 5 ? [...items, ...items, ...items] : items;

  return (
    <Swiper
      slidesPerView={1}
      spaceBetween={30}
      centeredSlides={true}
      loop={true}
      loopAdditionalSlides={1}
      autoplay={{
        delay: 6000,
        disableOnInteraction: false
      }}
      pagination={{
        clickable: true
      }}
      modules={[FreeMode, Autoplay]}
      className="cursor-grab"
      {...swiperOptions}
    >
      {validateItems.map((item, index) => (
        <SwiperSlide key={index}>{renderItem(item, index)}</SwiperSlide>
      ))}
    </Swiper>
  );
};

export default SwiperMobileSlider;
